var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "md-layout md-alignment-center-space-between",
      attrs: { "data-test-id": "top-toolbar-navigation" }
    },
    [
      _c("div", { staticClass: "block_left" }, [
        _c(
          "div",
          {
            staticClass: "nav__logo",
            attrs: { "data-test-id": "top-toolbar-logo" }
          },
          [_c("logotype")],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block_right" },
        [
          _vm.isLoggedIn
            ? _c("Notifications", {
                on: {
                  openDialog: _vm.openDialog,
                  openLymitDialog: _vm.openLymitDialog
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("LangSwitcher"),
          _vm._v(" "),
          _c("UserInfo", { ref: "userInfo" })
        ],
        1
      ),
      _vm._v(" "),
      _vm.activeDialog
        ? _c("AmlDialog", {
            attrs: {
              "data-test-id": "aml-dialog",
              active: _vm.activeDialog,
              values: _vm.activeDialogData,
              account: _vm.accountId
            },
            on: { close: _vm.closeDialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeLymitDialog
        ? _c("LymitDialog", {
            attrs: {
              "data-test-id": "lymit-dialog",
              active: _vm.activeLymitDialog,
              values: _vm.activeLymitDialogData,
              account: _vm.accountId
            },
            on: { close: _vm.closeLymitDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd97f58e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd97f58e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/Navbar.vue
// module id = XBXX
// module chunks = 1